import { TwoFAOutlineIcon } from 'foundations-assets/icons/components/TwoFAOutlineIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useDataPermissions } from '../../contexts/DataPermissionsContext';
import { ssoSettingsUrl } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function EnterpriseManagedAuthTile() {
  const {
    isEnterpriseManagedAuthEnabled,
    setIsEnterpriseManagedAuthEnabled
  } = useDataPermissions();
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "400",
    children: [/*#__PURE__*/_jsx(Tile, {
      children: /*#__PURE__*/_jsx(TileSection, {
        children: /*#__PURE__*/_jsxs(Flex, {
          gap: "300",
          alignItems: "start",
          children: [/*#__PURE__*/_jsx(IconHolder, {
            icon: TwoFAOutlineIcon,
            size: "400",
            padding: "200",
            borderRadius: "200",
            backgroundColor: "fill-accent-blue-subtle"
          }), /*#__PURE__*/_jsxs(Flex, {
            flexDirection: "column",
            gap: "100",
            flex: "1",
            children: [/*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              gap: "200",
              children: [/*#__PURE__*/_jsx(Text, {
                as: "h5",
                marginBlockEnd: "0",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "app-governance-lib.dataPermissions.enterpriseManagedAuth.title"
                })
              }), /*#__PURE__*/_jsx(Badge, {
                use: "beta",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "app-governance-lib.dataPermissions.enterpriseManagedAuth.betaBadge"
                })
              })]
            }), /*#__PURE__*/_jsx(Text, {
              color: "text-core-subtle",
              typography: "detail-200",
              marginBlockEnd: "0",
              children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
                message: "app-governance-lib.dataPermissions.enterpriseManagedAuth.description_jsx",
                options: {
                  linkProps: {
                    'data-selenium': 'data-permissions-ema-sso-settings-link',
                    href: ssoSettingsUrl()
                  }
                },
                elements: {
                  Link
                }
              })
            })]
          }), /*#__PURE__*/_jsx(Toggle, {
            "data-selenium": "data-permissions-ema-toggle",
            size: "extra-small",
            checked: isEnterpriseManagedAuthEnabled,
            onChange: event => setIsEnterpriseManagedAuthEnabled(event.target.checked)
          })]
        })
      })
    }), isEnterpriseManagedAuthEnabled && /*#__PURE__*/_jsx(Alert, {
      "data-selenium": "data-permissions-ema-enabled-alert",
      type: "warning",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app-governance-lib.dataPermissions.enterpriseManagedAuth.enabledAlert.title"
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app-governance-lib.dataPermissions.enterpriseManagedAuth.enabledAlert.description"
      })
    })]
  });
}